module.exports = __webpack_public_path__ + "c8961b3bc298e4cba5ceec2f1debf4fb.png";